import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

export default function WhatsAppWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [showPulse, setShowPulse] = useState(true);
  const whatsappNumber = "917075659696";

  useEffect(() => {
    // Auto-open widget after 3 seconds
    const openTimer = setTimeout(() => setIsOpen(true), 3000);
    // Stop pulse after 10 seconds
    const pulseTimer = setTimeout(() => setShowPulse(false), 10000);
    return () => { clearTimeout(openTimer); clearTimeout(pulseTimer); };
  }, []);

  return (
    <div data-testid="whatsapp-widget" className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-50">
      {isOpen && (
        <div
          data-testid="whatsapp-popup"
          className="absolute bottom-16 right-0 w-72 bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden mb-2"
        >
          <div className="bg-[#075E54] p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                  <MessageCircle className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">Dr. Dileep's Clinic</p>
                  <p className="text-green-200 text-xs">Typically replies in minutes</p>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-white/70 hover:text-white">
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
          <div className="p-4 bg-[#ECE5DD]">
            <div className="bg-white rounded-lg p-3 shadow-sm">
              <p className="text-sm text-slate-700">
                Hello! How can we help you today? Feel free to ask about our services or book an appointment.
              </p>
              <p className="text-xs text-slate-400 mt-1 text-right">Dr. Dileep's Team</p>
            </div>
          </div>
          <div className="p-3">
            <a
              href={`https://api.whatsapp.com/send?phone=${whatsappNumber}&text=Hello%20Dr.%20Dileep%2C%20I%20would%20like%20to%20book%20an%20appointment.`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-send-btn"
              className="block w-full bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold py-2.5 rounded-lg text-center text-sm transition-colors"
            >
              Start Chat
            </a>
          </div>
        </div>
      )}

      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid="whatsapp-toggle-btn"
        className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BD5A] text-white shadow-lg flex items-center justify-center transition-all hover:scale-110"
      >
        {isOpen ? (
          <X className="w-6 h-6" />
        ) : (
          <MessageCircle className="w-6 h-6" />
        )}
        {showPulse && !isOpen && (
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        )}
      </button>
    </div>
  );
}
